import React from 'react'
import PropTypes from 'prop-types'
import './styles.scss'

const Toggle = ({ checked, onChange, disabled, inputId, labelText }) => {
  const handleOnChange = (e) => {
    if (onChange) {
      onChange(e.target.checked)
    }
  }

  return (
    <label className="toggle-switch">
      <input
        id={inputId}
        type="checkbox"
        checked={checked}
        onChange={handleOnChange}
        disabled={disabled}
      />
      <span className="toggle-switch__slider"/>
      {labelText && <span className="toggle-switch__label">{labelText}</span>}
    </label>
  )
}

Toggle.propTypes = {
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  inputId: PropTypes.string,
  labelText: PropTypes.string,
}

Toggle.defaultProps = {
  disabled: false,
  labelText: '',
}

export default Toggle
